var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedGreenLockBlackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.143066,
    width: 87.714,
    height: 87.714,
    rx: 43.857,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2578_6003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0044 49.4L42.5429 59L61.0044 35",
    stroke: "#16C098",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4478 31.5C35.4478 30.764 34.8318 30.1667 34.0728 30.1667H33.3853V28.8333C33.3853 26.9927 31.8459 25.5 29.9478 25.5C28.0496 25.5 26.5103 26.9927 26.5103 28.8333V30.1667H25.8228C25.0638 30.1667 24.4478 30.764 24.4478 31.5V38.1667C24.4478 38.9027 25.0638 39.5 25.8228 39.5H34.0728C34.8318 39.5 35.4478 38.9027 35.4478 38.1667V31.5ZM27.8853 28.8344C27.8853 27.7298 28.8086 26.8344 29.9478 26.8344C31.0869 26.8344 32.0102 27.7298 32.0102 28.8344V30.1677H27.8853V28.8344Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2578_6003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(24.0024 24.5781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedGreenLockBlackIcon);
export default __webpack_public_path__ + "static/media/checkedGreenLockBlackIcon.9311ca3c534d0e7f329dab47f5713cfd.svg";
export { ForwardRef as ReactComponent };